module.exports = __webpack_public_path__ + "static/Brochures-af68e54d64e439332f7c0d8caa28174a.svg";